import {
  faClipboard,
  faClipboardCheck,
} from '@fortawesome/free-solid-svg-icons';
import { ReactElement, ReactNode, useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button } from '.';

const COPY_TO_CLIPBOARD_RESET_DELAY = 3000;

type CopyableProps = {
  text: string;
  children?: ReactNode;
  pending?: boolean;
};

/**
 * A value with a button that copies it to the clipboard
 */
export function Copyable({
  text,
  children,
  pending,
}: CopyableProps): ReactElement {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      const timeout = setTimeout(
        () => setCopied(false),
        COPY_TO_CLIPBOARD_RESET_DELAY
      );

      return () => clearTimeout(timeout);
    }
  }, [copied]);

  return (
    <>
      {children ?? <code>{text}</code>}{' '}
      <CopyToClipboard text={text} onCopy={() => setCopied(true)}>
        <Button
          icon={copied ? faClipboardCheck : faClipboard}
          loading={pending}
          minimal
        />
      </CopyToClipboard>
    </>
  );
}
